export type NoticeCategory = 'urgent' | 'service' | 'loisirs' | 'personnalise' | 'municipal'

export interface Notice {
  id: string
  category: NoticeCategory
  title: string
  description: string
  when: string
  ago: string
  context?: string
  unread: boolean
}

export const categoryLabels: Record<NoticeCategory, string> = {
  urgent: 'Urgent',
  service: 'Service',
  loisirs: 'Vie communautaire',
  personnalise: 'Personnalisé',
  municipal: 'Vie municipale',
}

export const notices: Notice[] = [
  {
    id: 'ebullition',
    category: 'urgent',
    title: 'Avis d’ébullition',
    description: 'Votre adresse est concernée. Faites bouillir l’eau une minute avant consommation.',
    when: 'Aujourd’hui · 14 h 30',
    ago: 'il y a 12 min',
    context: '112, route 138',
    unread: true,
  },
  {
    id: 'centre-de-tri',
    category: 'service',
    title: 'Centre de tri fermé samedi',
    description: 'Le centre de tri sera fermé le samedi 19 septembre. Prochaine ouverture selon l’horaire habituel.',
    when: 'Aujourd’hui · 8 h 15',
    ago: 'ce matin',
    context: 'Centre de tri de Baie-Trinité',
    unread: true,
  },
  {
    id: 'chats-errants',
    category: 'municipal',
    title: 'Journées de stérilisation de chats errants',
    description: 'Deux journées sont organisées les 25 et 26 septembre 2026.',
    when: '17 septembre',
    ago: '17 sept.',
    unread: true,
  },
  {
    id: 'req-2841',
    category: 'service',
    title: 'Votre demande a été mise à jour',
    description: 'Nid-de-poule — #REQ-2841 · Nouveau statut : En traitement',
    when: '28 août · 9 h 05',
    ago: '28 août',
    context: '112, route 138',
    unread: false,
  },
  {
    id: 'activite-19',
    category: 'loisirs',
    title: 'Une belle activité samedi',
    description: 'Une activité communautaire est organisée au village le samedi 19 septembre.',
    when: '15 septembre',
    ago: '15 sept.',
    unread: false,
  },
  {
    id: 'milo-rappel',
    category: 'personnalise',
    title: 'Rappel pour Milo',
    description: 'Vaccin prévu le 14 octobre 2026.',
    when: '20 août',
    ago: '20 août',
    context: 'Milo · licence animale',
    unread: false,
  },
  {
    id: 'bureau-ferme',
    category: 'municipal',
    title: 'Bureau municipal fermé',
    description: 'Le bureau était fermé les 3, 4 et 7 septembre 2026.',
    when: '2 septembre',
    ago: '2 sept.',
    unread: false,
  },
  {
    id: 'seance-extraordinaire',
    category: 'municipal',
    title: 'Avis public — séance extraordinaire',
    description: 'Séance extraordinaire le mardi 25 août 2026 à 19 h.',
    when: '20 août',
    ago: '20 août',
    unread: false,
  },
]

export const activeAlert = {
  title: 'Avis d’ébullition — votre adresse est touchée',
  address: '112, route 138',
  addressLabel: 'Adresse principale',
  since: 'Depuis aujourd’hui, 14 h 30',
  summary:
    'Un avis d’ébullition est actuellement en vigueur pour cette adresse enregistrée dans votre profil.',
  concerns: 'L’adresse 112, route 138 est dans la zone touchée.',
  todo: 'Faites bouillir l’eau au moins une minute avant consommation, selon l’avis officiel de la Municipalité.',
  questions: ['Puis-je boire l’eau ?', 'Puis-je en donner à mon animal ?', 'Quand l’avis sera-t-il levé ?'],
}

export const resolvedAlert = {
  title: 'Avis d’ébullition levé — réseau d’aqueduc',
  detail: 'L’eau est de nouveau propre à la consommation depuis le 24 août à 16 h.',
}

export const avisChips = ['Mes alertes importantes', 'Non lus', 'Cette semaine', 'Paramètres']

export const avisQuestions = [
  'Pourquoi ai-je reçu cet avis ?',
  'Quels avis sont essentiels ?',
  'Comment changer mon numéro de téléphone ?',
  'Quelles adresses sont associées à mes alertes ?',
]

export interface ChannelPref {
  id: string
  label: string
  destination: string
  enabled: boolean
}

export const channelPrefs: ChannelPref[] = [
  { id: 'push', label: 'Notifications mobiles', destination: 'Application bciti+', enabled: true },
  { id: 'courriel', label: 'Courriel', destination: 'charlotte.bouchard@courriel.com', enabled: true },
  { id: 'sms', label: 'SMS', destination: '(418) •••-0184', enabled: false },
]

export interface TopicPref {
  id: string
  label: string
  description: string
  enabled: boolean
}

export const topicPrefs: TopicPref[] = [
  {
    id: 'collectes',
    label: 'Collectes et centre de tri',
    description: 'Rappels de collecte et fermetures du centre de tri',
    enabled: true,
  },
  {
    id: 'loisirs',
    label: 'Vie communautaire',
    description: 'Activités, bibliothèque et évènements du village',
    enabled: true,
  },
  {
    id: 'travaux',
    label: 'Voirie et déneigement',
    description: 'Travaux, entraves et opérations de déneigement',
    enabled: true,
  },
  {
    id: 'municipal',
    label: 'Vie municipale',
    description: 'Séances du conseil, avis publics et fermetures du bureau',
    enabled: false,
  },
  {
    id: 'personnalise',
    label: 'Services personnalisés',
    description: 'Informations liées aux services que vous utilisez',
    enabled: true,
  },
]

export const alertPlaces = [
  { id: 'principale', address: '112, route 138', label: 'Adresse principale' },
  { id: 'villegiature', address: 'Chemin du Vieux-Phare', label: 'Bail de villégiature' },
]
